import Distpicker from './src/distpicker.vue';

Distpicker.install = function (Vue) {
    Vue.component(Distpicker.name, Distpicker);
};

export default Distpicker;